import script from "./Menu.vue?vue&type=script&lang=ts&setup=true"
export * from "./Menu.vue?vue&type=script&lang=ts&setup=true"

import "./Menu.vue?vue&type=style&index=0&id=1b7b1c77&lang=scss&scoped=true"

import exportComponent from "/Users/mayo/htdocs/halp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b7b1c77"]])

export default __exports__